import availabilitiesAndConstraintsService from 'src/services/inventory/sales-restrictions/AvailabilitiesAndConstraintsService'
import availableStockService from 'src/services/inventory/sales-restrictions/AvailableStockService'
import { getInventoryStrategy } from 'src/services/inventory/sales-restrictions/helpers'

class IsOutOfStockService {
  static #instance = null

  static #availabilitiesAndConstraintsService = null
  static #availableStockService = null

  constructor ({
    availabilitiesAndConstraintsService,
    availableStockService
  }) {
    if (!IsOutOfStockService.#instance) {
      IsOutOfStockService.#availabilitiesAndConstraintsService = availabilitiesAndConstraintsService
      IsOutOfStockService.#availableStockService = availableStockService

      IsOutOfStockService.#instance = this
    }
    return IsOutOfStockService.#instance
  }

  isOutOfStock (model, options) {
    const inventoryStrategy = getInventoryStrategy()

    if (_.isNil(inventoryStrategy)) return false

    if (!IsOutOfStockService.#availabilitiesAndConstraintsService.isModelInventoriable(model)) return false

    switch (model.typeName) {
      case 'ItemVariation':
        return IsOutOfStockService.#isItemVariationOutOfStock(model, options)
      case 'Modifier':
        return IsOutOfStockService.#isModifierOutOfStock(model, options)
      case 'Item':
        return IsOutOfStockService.#isItemOutOfStock(model, options)
      case 'RegisterButton':
        switch (model.type) {
          case 'item':
            return IsOutOfStockService.#isItemOutOfStock(model.item, options)
          case 'item-variation':
            return IsOutOfStockService.#isItemVariationOutOfStock(model.itemVariation, options)
          default:
            return false
        }
      default:
        return false
    }
  }

  static #isItemVariationOutOfStock (itemVariation, options) {
    if (!itemVariation.hasRecipe) return false

    const available = IsOutOfStockService.#availableStockService.availableStock(itemVariation, options, true)

    if (_.isNil(available)) return false

    return available <= 0
  }

  static #isModifierOutOfStock (modifier, options) {
    if (!modifier.hasRecipe) return false

    const available = IsOutOfStockService.#availableStockService.availableStock(modifier, options)

    if (_.isNil(available)) return false

    return available <= 0
  }

  static #isItemOutOfStock (item, options) {
    return _.every(item.activeItemVariations, activeItemVariation => {
      /**
       * Check whether the item variations are out of stock, or whether any of
       * the modifier set minimum requirements can't be fulfilled because the
       * modifiers are out of stock when paired with the item variation.
       */
      return IsOutOfStockService.#isItemVariationOutOfStock(activeItemVariation, options) || _.some(item.itemModifierSets?.data, itemModifierSet => {
        if (!itemModifierSet.minSelectionCount) return false

        const numOfModifiersInStock = _(itemModifierSet.modifierSet.activeModifiers)
          .filter(activeModifier => !IsOutOfStockService.#isModifierOutOfStock(activeModifier, { ...options, item, selectedItemVariationId: activeItemVariation.id }))
          .value().length

        return numOfModifiersInStock < itemModifierSet.minSelectionCount
      })
    })
  }
}

const isOutOfStockService = new IsOutOfStockService({
  availabilitiesAndConstraintsService,
  availableStockService
})

export default isOutOfStockService
